import { ErrorObject } from '@qpr/client-library/dist/esm/ErrorContext';

export interface E2Eprocess {
  _id: string;
  meaId: string;
  type: string;
  title: string;
  description?: string;
  children: E2Eprocess[];
}

export interface ProcessIntegrationViewState {
  e2eProcesses: E2Eprocess[];
  error?: ErrorObject;
}

const initialState = {
  e2eProcesses: []
} as ProcessIntegrationViewState;

export default initialState;
